import React from 'react';
import { useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useShell } from '@/contexts/shell-context';
import { useHelpForPath } from './use-help-entries';

/** Header Help button: shown only on screens with at least one Help entry; opens the Help sheet. */
export function HelpHeaderButton() {
  const { pathname } = useLocation();
  const { helpOpen, openHelp } = useShell();
  const entries = useHelpForPath(pathname);
  if (entries.length === 0) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn('h-10 w-10 shrink-0 rounded-lg', helpOpen && 'ring-2 ring-primary ring-offset-2 ring-offset-background')}
      aria-label="Help for this screen"
      aria-expanded={helpOpen}
      title="Help for this screen"
      onClick={openHelp}
    >
      <HelpCircle className="h-5 w-5" />
    </Button>
  );
}
